import { render } from "./PaymentSelectVendorBankDialog.vue?vue&type=template&id=5d3def94&scoped=true"
import script from "./PaymentSelectVendorBankDialog.vue?vue&type=script&lang=ts"
export * from "./PaymentSelectVendorBankDialog.vue?vue&type=script&lang=ts"

import "./PaymentSelectVendorBankDialog.vue?vue&type=style&index=0&id=5d3def94&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5d3def94"

export default script